import React from "react";

const Skills = () => {
  return (
    <section className="skill_sec">
      <h2 className="home_heading">Skills - </h2>
      <div className="skill_sec__lists">
        <h3>Programming Languages</h3>
        <span className="skill_sec__lists__items">Javascript</span>
        <span className="skill_sec__lists__items">Typescript</span>
        <span className="skill_sec__lists__items">HTML/CSS</span>
        <span className="skill_sec__lists__items">Python</span>
        <span className="skill_sec__lists__items">Node</span>
      </div>
      <div className="skill_sec__lists">
        <h3>Libraries & Frameworks</h3>
        <span className="skill_sec__lists__items">React.js</span>
        <span className="skill_sec__lists__items">Next.js</span>
        <span className="skill_sec__lists__items">Vue.js</span>
        <span className="skill_sec__lists__items">React Native</span>
        <span className="skill_sec__lists__items">Redux</span>
      </div>
      <div className="skill_sec__lists">
        <h3>Tools</h3>
        <span className="skill_sec__lists__items">Git</span>
        <span className="skill_sec__lists__items">Webpack</span>
        <span className="skill_sec__lists__items">RESTful</span>
        <span className="skill_sec__lists__items">JSON</span>
        <span className="skill_sec__lists__items">Unit/e2e Testing</span>
        <span className="skill_sec__lists__items">Jira</span>
        <span className="skill_sec__lists__items">Firebase</span>
        <span className="skill_sec__lists__items">Vercel</span>
      </div>
      <div className="skill_sec__lists">
        <h3>Design</h3>
        <span className="skill_sec__lists__items">Figma</span>
        <span className="skill_sec__lists__items">Photoshop</span>
        <span className="skill_sec__lists__items">Responsive Design</span>
        <span className="skill_sec__lists__items">Invision</span>
      </div>
    </section>
  );
};

export default Skills;
